import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

export const LoginOldLink = () => {
    const navigate = useNavigate()

    useEffect(() => {
        navigate('/auth/login')
    }, [navigate])

    return null
}
